import { useEffect, useState } from 'react'
import FlipDigit from './FlipDigit.jsx'

export default function TimerFlip({ duration, running, onTimeout }) {
  const [time, setTime] = useState(duration)

  useEffect(() => {
    setTime(duration)
  }, [duration])

  useEffect(() => {
    if (!running) return
    const endTime = Date.now() + duration * 1000
    let timeoutTriggered = false
    const interval = setInterval(() => {
      const remainingMs = Math.max(0, endTime - Date.now())
      const remainingSeconds = remainingMs === 0 ? 0 : Math.ceil(remainingMs / 1000)
      setTime(remainingSeconds)
      if (remainingMs <= 0 && !timeoutTriggered) {
        timeoutTriggered = true
        clearInterval(interval)
        setTimeout(() => onTimeout(), 1000)
      }
    }, 16)
    return () => clearInterval(interval)
  }, [running, duration, onTimeout])

  const tens = Math.floor(time / 10)
  const ones = time % 10

  return (
    <div className="timer-flip-wrapper">
      <FlipDigit value={tens} />
      <FlipDigit value={ones} />
    </div>
  )
}